import React from 'react';
import { Helmet } from "react-helmet";
import Header from 'clayton-chcom/dist/components/Shared/Header/Header';
import Footer from 'clayton-chcom/dist/components/Shared/Footer/Footer';
import Typography from "pubweb-smokey/dist/components/Typography/Typography";

import NotFoundContent from 'clayton-chcom/dist/components/NotFound/NotFoundContent';
 
const NotFoundPage = () => {
    return ( <Typography>
                <Helmet
                    htmlAttributes={{ lang: 'en' }}
                >
                    <title>Not Found | Clayton</title>
                    <meta name="description" content=" Clayton has been providing affordable, quality homes since 1956. Learn more about our recent company announcements and publicly released information." />
                    <link rel="icon" type="image/x-icon" href="https://www.claytonhomes.com/favicon.ico?v=1" />
                </Helmet>
                <Header 
                    internalLink={false} 
                    addSiteUrl={true} 
                    siteUrlOverride="https://www.claytonhomes.com"
                    hideDomainSpecificActions={true}
                />
                <NotFoundContent 
                    addSiteUrl={true}
                    internalLink={false}
                    siteUrlOverride="https://www.claytonhomes.com"
                />
                <Footer 
                    internalLink={false} 
                    addSiteUrl={true} 
                    siteUrlOverride="https://www.claytonhomes.com"
                />      
          </Typography> )
}
 
export default NotFoundPage;